import { createContext, useContext } from "react";

export interface TargetingValidationApi {
  version: number;
}

export const TargetingValidationContext = createContext<TargetingValidationApi>({ version: 0 });

export const useTargetingValidation = () => useContext(TargetingValidationContext);

export { validateCampaignName, normalizeCampaignName } from "campaign-builder/state";
